import { render } from "./BaseMenuView.vue?vue&type=template&id=54725fb7&scoped=true"
import script from "./BaseMenuView.vue?vue&type=script&lang=js"
export * from "./BaseMenuView.vue?vue&type=script&lang=js"

import "./BaseMenuView.vue?vue&type=style&index=0&id=54725fb7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54725fb7"]])

export default __exports__